import { createFileRoute } from "@tanstack/react-router";
import { ReportsScreen, type ReportsSearch } from "../screens/staff/ReportsScreen.tsx";

/** `/sysadmin/reports`: what people say they miss ("Missing a data source?") and what browsers refused to load. */
export const Route = createFileRoute("/_staff/sysadmin/reports")({
  validateSearch: (search: Record<string, unknown>): ReportsSearch =>
    search.tab === "security" ? { tab: "security" } : {},
  component: ReportsScreen,
});
